import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['btn', 'from'];

  connect() {
    const $btn = $(this.btnTarget);
    $btn.tooltip({ trigger: 'manual' });

    this.btnTarget.addEventListener('click', () => {
      this.fromTarget.select();
      const result = document.execCommand('copy');
      if (!result) {
        alert('コピーに失敗しました。');
        return;
      }

      $btn.tooltip('show');
      setTimeout(() => {
        $btn.tooltip('hide');
      }, 1000);
    });
  }
}
